"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _UITileSection = _interopRequireDefault(require("UIComponents/tile/UITileSection"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UILockedFeature = _interopRequireDefault(require("ui-addon-upgrades/decorators/UILockedFeature"));

var _UILock = _interopRequireDefault(require("ui-addon-upgrades/icons/UILock"));

var _RuleRow = _interopRequireDefault(require("lead-flows-ui/components/editor/TargetingOptions/RuleRow"));

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var _Scopes = require("lead-flows-ui/selectors/Scopes");

var upgradeData = {
  app: 'lead-flows',
  screen: 'editor',
  uniqueId: 'advanced-targeting-options',
  upgradeProduct: 'marketing-starter'
};

var TargetingOptionsManager =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TargetingOptionsManager, _Component);
  (0, _createClass2.default)(TargetingOptionsManager, null, [{
    key: "propTypes",
    get: function get() {
      return {
        addValidationError: _react.PropTypes.func.isRequired,
        hasQueryParamAccess: _react.PropTypes.bool.isRequired,
        hasExclusionAccess: _react.PropTypes.bool.isRequired,
        hasContainsAccess: _react.PropTypes.bool.isRequired,
        removeValidationError: _react.PropTypes.func.isRequired,
        targetingOptions: _react.PropTypes.object.isRequired,
        updateDyno: _react.PropTypes.func.isRequired
      };
    }
  }]);

  function TargetingOptionsManager(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TargetingOptionsManager);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TargetingOptionsManager).call(this, props));
    var blacklistedUrls = props.targetingOptions.blackList.exactMatchValues;
    var blacklistedQueryParams = props.targetingOptions.blackList.queryParamFilterValues;
    var blacklistedStartsWithUrls = props.targetingOptions.blackList.startsWithValues;
    var blacklistedContainsValues = props.targetingOptions.blackList.containsValues;
    var hasBlackLists = Boolean(blacklistedUrls.length + Object.keys(blacklistedQueryParams).length + blacklistedStartsWithUrls.length + blacklistedContainsValues.length);
    var whitelistedUrls = props.targetingOptions.whiteList.exactMatchValues;
    var whitelistedQueryParams = props.targetingOptions.whiteList.queryParamFilterValues;
    var whitelistedStartsWithUrls = props.targetingOptions.whiteList.startsWithValues;
    var whitelistedContainsValues = props.targetingOptions.whiteList.containsValues;
    var hasWhiteLists = Boolean(whitelistedUrls.length + Object.keys(whitelistedQueryParams).length + whitelistedStartsWithUrls.length + whitelistedContainsValues.length);
    _this.buildUrlList = _this.buildUrlList.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleAddHideRules = _this.handleAddHideRules.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleAddRule = _this.handleAddRule.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInputBlur = _this.handleInputBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRuleChange = _this.handleRuleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDelete = _this.handleDelete.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderShowRules = _this.renderShowRules.bind((0, _assertThisInitialized2.default)(_this));
    _this.maybeRenderSeparator = _this.maybeRenderSeparator.bind((0, _assertThisInitialized2.default)(_this));
    _this.maybeRenderAddHideRule = _this.maybeRenderAddHideRule.bind((0, _assertThisInitialized2.default)(_this));
    _this.maybeRenderHideRules = _this.maybeRenderHideRules.bind((0, _assertThisInitialized2.default)(_this));
    _this.validateInputs = _this.validateInputs.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      showHideRules: hasBlackLists,
      enableAddRules: hasWhiteLists,
      rules: {
        blackList: _this.buildUrlList('hide'),
        whiteList: _this.buildUrlList('show')
      }
    };
    return _this;
  }

  (0, _createClass2.default)(TargetingOptionsManager, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.validateInputs(this.props.targetingOptions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.validateInputs(this.props.targetingOptions);
    }
  }, {
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "leadFlowEditor.leadFlowOptionsEditor.targetingOptions." + suffix;
    }
  }, {
    key: "buildUrlList",
    value: function buildUrlList(type) {
      var targetingOptions = this.props.targetingOptions;
      var blacklistedUrls = targetingOptions.blackList.exactMatchValues;
      var whitelistedUrls = targetingOptions.whiteList.exactMatchValues;
      var blacklistedQueryParams = targetingOptions.blackList.queryParamFilterValues;
      var whitelistedQueryParams = targetingOptions.whiteList.queryParamFilterValues;
      var blacklistedStartsWithUrls = targetingOptions.blackList.startsWithValues;
      var whitelistedStartsWithUrls = targetingOptions.whiteList.startsWithValues;
      var blacklistedContainsValues = targetingOptions.blackList.containsValues;
      var whitelistedContainsValues = targetingOptions.whiteList.containsValues;
      var urlList = type === 'show' ? whitelistedUrls : blacklistedUrls;
      var queryParametersList = type === 'show' ? whitelistedQueryParams : blacklistedQueryParams;
      var startsList = type === 'show' ? whitelistedStartsWithUrls : blacklistedStartsWithUrls;
      var containsValues = type === 'show' ? whitelistedContainsValues : blacklistedContainsValues;
      var normalisedQueryParamsList = Object.keys(queryParametersList).reduce(function (list, key) {
        // necessary to have one rule for each query parameter with a repetead key
        for (var i = 0; i < queryParametersList[key].length; i++) {
          list.push((0, _defineProperty2.default)({}, key, queryParametersList[key][i]));
        }

        return list;
      }, []);

      var getRuleContent = function getRuleContent(rule) {
        return rule !== null && (0, _typeof2.default)(rule) === 'object' ? Object.keys(rule)[0] : rule;
      };

      var urlRules = urlList.map(function (rule) {
        var ruleContent = getRuleContent(rule);
        return {
          value: rule,
          isParam: false,
          startsWith: false,
          isContains: false,
          isExactMatch: true,
          key: ruleContent
        };
      });
      var startsListRules = startsList.map(function (rule) {
        var ruleContent = getRuleContent(rule);
        return {
          value: rule,
          isParam: false,
          startsWith: true,
          isContains: false,
          isExactMatch: false,
          key: ruleContent
        };
      });
      var containsValuesRules = containsValues.map(function (rule) {
        var ruleContent = getRuleContent(rule);
        return {
          value: rule,
          isParam: false,
          startsWith: false,
          isContains: true,
          isExactMatch: false,
          key: ruleContent
        };
      });
      var normalisedQueryParamsListRules = normalisedQueryParamsList.map(function (rule) {
        var ruleContent = getRuleContent(rule);
        return {
          value: rule[ruleContent],
          isParam: true,
          startsWith: false,
          isContains: false,
          isExactMatch: false,
          key: ruleContent
        };
      });
      var rules = [].concat((0, _toConsumableArray2.default)(urlRules), (0, _toConsumableArray2.default)(startsListRules), (0, _toConsumableArray2.default)(containsValuesRules), (0, _toConsumableArray2.default)(normalisedQueryParamsListRules));
      return rules.length ? rules : [{
        value: '',
        isParam: false,
        startsWith: false,
        isContains: false,
        isExactMatch: false,
        key: ''
      }];
    }
  }, {
    key: "handleAddHideRules",
    value: function handleAddHideRules() {
      var rules = this.state.rules;

      if (!rules.blackList.length) {
        rules.blackList.push({
          value: '',
          isParam: false,
          startsWith: false,
          isContains: false,
          isExactMatch: false,
          key: ''
        });
      }

      this.setState({
        rules: rules,
        showHideRules: true
      });
    }
  }, {
    key: "handleAddRule",
    value: function handleAddRule(type) {
      var _this2 = this;

      var list = type === 'show' ? 'whiteList' : 'blackList';
      return function () {
        var rules = _this2.state.rules;
        rules[list].push({
          value: '',
          isParam: false,
          startsWith: false,
          isContains: false,
          isExactMatch: true,
          key: '',
          newlyAdded: true
        });

        _this2.setState({
          rules: rules
        });
      };
    }
  }, {
    key: "handleInputBlur",
    value: function handleInputBlur() {
      this.validateInputs(this.props.targetingOptions);
    }
  }, {
    key: "handleRuleChange",
    value: function handleRuleChange(data, isParam, isWhiteList, startsWith, isContains, ruleType, currentAction, index, key) {
      var _this3 = this;

      var _this$props = this.props,
          targetingOptions = _this$props.targetingOptions,
          updateDyno = _this$props.updateDyno;
      var list = isWhiteList ? 'whiteList' : 'blackList';
      var rules = this.state.rules;
      var urlList = [];
      var startsWithList = [];
      var containsValues = [];
      var queryParametersList = {};
      this.handleDelete(data, isParam, isWhiteList, startsWith, isContains, index, key, true);

      switch (ruleType) {
        case 'is':
          rules[list][index] = {
            value: data,
            isParam: false,
            startsWith: false,
            isContains: false,
            isExactMatch: true,
            key: ''
          };
          break;

        case 'begins':
          rules[list][index] = {
            value: data,
            isParam: false,
            startsWith: true,
            isContains: false,
            isExactMatch: false,
            key: ''
          };
          break;

        case 'queryParameters':
          rules[list][index] = {
            value: data,
            isParam: true,
            startsWith: false,
            isContains: false,
            isExactMatch: false,
            key: key
          };
          break;

        case 'website':
          rules[list][index] = {
            value: '',
            isParam: false,
            startsWith: false,
            isContains: false,
            isExactMatch: false,
            key: ''
          };
          break;

        case 'all':
          rules[list][index] = {
            value: '',
            isParam: false,
            startsWith: false,
            isContains: false,
            isExactMatch: false,
            key: ''
          };
          break;

        case 'contains':
          rules[list][index] = {
            value: data,
            isParam: false,
            startsWith: false,
            isContains: true,
            isExactMatch: false,
            key: ''
          };
          break;

        default:
          break;
      }

      this.setState({
        enableAddRules: Boolean(ruleType !== 'all' && currentAction !== 'all'),
        rules: rules
      }, function () {
        _this3.state.rules[list].forEach(function (rule) {
          var value = Array.isArray(rule.value) ? rule.value[0] : rule.value;

          if (rule.isParam) {
            if (!queryParametersList[rule.key]) queryParametersList[rule.key] = [];
            queryParametersList[rule.key].push(value);
          } else if (rule.startsWith) {
            startsWithList.push(value);
          } else if (rule.isContains) {
            containsValues.push(value);
          } else if (rule.isExactMatch) {
            urlList.push(value);
          }
        });

        targetingOptions[list].exactMatchValues = urlList;
        targetingOptions[list].startsWithValues = startsWithList;
        targetingOptions[list].containsValues = containsValues;
        targetingOptions[list].queryParamFilterValues = queryParametersList;
        updateDyno({
          targetingOptions: targetingOptions,
          urlWhitelist: null
        });
      });
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(data, isParam, isWhiteList, startsWith, isContains, index, key, reassign) {
      var _this$props2 = this.props,
          targetingOptions = _this$props2.targetingOptions,
          updateDyno = _this$props2.updateDyno;
      var rules = this.state.rules;
      var list = isWhiteList ? 'whiteList' : 'blackList';
      var rulePropIndex;

      if (isParam) {
        if (isWhiteList && targetingOptions[list].queryParamFilterValues[key] && targetingOptions[list].queryParamFilterValues[key].length > 1) {
          targetingOptions[list].queryParamFilterValues[key].splice(targetingOptions[list].queryParamFilterValues[key].indexOf(data), 1);
        } else {
          delete targetingOptions[list].queryParamFilterValues[key];
        }
      }

      if (startsWith) {
        rulePropIndex = targetingOptions[list].startsWithValues.indexOf(data);
        targetingOptions[list].startsWithValues.splice(rulePropIndex, 1);
      }

      if (isContains) {
        rulePropIndex = targetingOptions[list].startsWithValues.indexOf(data);
        targetingOptions[list].containsValues.splice(rulePropIndex, 1);
      }

      if (!startsWith && !isParam && !isContains) {
        rulePropIndex = targetingOptions[list].exactMatchValues.indexOf(data);
        targetingOptions[list].exactMatchValues.splice(rulePropIndex, 1);
      }

      if (!reassign) {
        rules[list].splice(index, 1);
        this.setState({
          rules: rules,
          showHideRules: Boolean(this.state.rules.blackList.length)
        });
        this.validateInputs(targetingOptions);
      }

      updateDyno({
        targetingOptions: targetingOptions,
        urlWhitelist: null
      });
    }
  }, {
    key: "validateInputs",
    value: function validateInputs(targetingOptions) {
      var _this$props3 = this.props,
          addValidationError = _this$props3.addValidationError,
          removeValidationError = _this$props3.removeValidationError;
      var blacklistedUrls = targetingOptions.blackList.exactMatchValues;
      var whitelistedUrls = targetingOptions.whiteList.exactMatchValues;
      var blacklistedQueryParams = targetingOptions.blackList.queryParamFilterValues;
      var whitelistedQueryParams = targetingOptions.whiteList.queryParamFilterValues;
      var blacklistedStartsWithUrls = targetingOptions.blackList.startsWithValues;
      var whitelistedStartsWithUrls = targetingOptions.whiteList.startsWithValues;
      var blacklistedContainsValues = targetingOptions.blackList.containsValues;
      var whitelistedContainsValues = targetingOptions.whiteList.containsValues;
      var urls = blacklistedUrls.concat(whitelistedUrls).concat(blacklistedStartsWithUrls).concat(whitelistedStartsWithUrls);
      var queryParams = Object.keys(blacklistedQueryParams).concat(Object.keys(whitelistedQueryParams));
      var allValidUrls = urls.every(function (url) {
        return (0, _ValidationUtils.isValidDynoUrl)(url);
      });
      var allValidQueryParams = queryParams.every(function (key) {
        return blacklistedQueryParams[key] === undefined ? whitelistedQueryParams[key][0].length && key.length : blacklistedQueryParams[key][0].length && key.length;
      });
      var allValidContainsValues = blacklistedContainsValues.concat(whitelistedContainsValues).every(function (key) {
        return Boolean(key);
      });

      if (allValidUrls) {
        removeValidationError('targetingOptionsUrls', 'options');
      } else {
        addValidationError('targetingOptionsUrls', this.getLangKey('error.urls'), 'options');
      }

      if (allValidContainsValues) {
        removeValidationError('targetingOptionsContains', 'options');
      } else {
        addValidationError('targetingOptionsContains', this.getLangKey('error.containsValues'), 'options');
      }

      if (allValidQueryParams) {
        removeValidationError('targetingOptionsParams', 'options');
      } else {
        addValidationError('targetingOptionsParams', this.getLangKey('error.queryParams'), 'options');
      }
    }
  }, {
    key: "maybeRenderSeparator",
    value: function maybeRenderSeparator() {
      if (!this.state.showHideRules) return null;
      return _react.default.createElement("div", {
        className: "targeting-options__separator"
      }, _react.default.createElement("div", {
        className: "targeting-options__separator__line"
      }), _react.default.createElement("span", {
        className: "targeting-options__separator__and"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('and')
      })), _react.default.createElement("div", {
        className: "targeting-options__separator__line"
      }));
    }
  }, {
    key: "maybeRenderAddHideRule",
    value: function maybeRenderAddHideRule() {
      var showHideRules = this.state.showHideRules;
      var hasExclusionAccess = this.props.hasExclusionAccess;
      if (showHideRules) return null;

      if (hasExclusionAccess) {
        return _react.default.createElement(_UIButton.default, {
          className: "targeting-options__rules__add-button hide",
          onClick: this.handleAddHideRules,
          use: "link"
        }, _react.default.createElement(_UIIcon.default, {
          name: 'add'
        }), _react.default.createElement(_FormattedMessage.default, {
          message: this.getLangKey('addHideRules')
        }));
      }

      return _react.default.createElement(_UILockedFeature.default, {
        modalKey: "leadflows-blacklist",
        upgradeData: upgradeData,
        modalMountDelay: 0
      }, _react.default.createElement(_UIButton.default, {
        className: "targeting-options__rules__add-button hide",
        use: "link"
      }, _react.default.createElement(_UIIcon.default, {
        name: 'add'
      }), _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('addHideRules')
      }), _react.default.createElement(_UILock.default, null)));
    }
  }, {
    key: "maybeRenderHideRules",
    value: function maybeRenderHideRules() {
      var _this4 = this;

      var _this$props4 = this.props,
          hasQueryParamAccess = _this$props4.hasQueryParamAccess,
          hasExclusionAccess = _this$props4.hasExclusionAccess,
          hasContainsAccess = _this$props4.hasContainsAccess,
          targetingOptions = _this$props4.targetingOptions;
      var rulesList = this.state.rules.blackList;
      if (!this.state.showHideRules) return null;
      return _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "targeting-options__manager-title"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('titleHide')
      })), _react.default.createElement(_UITile.default, {
        compact: true
      }, _react.default.createElement(_UITileSection.default, null, rulesList.map(function (rule, index) {
        return _react.default.createElement(_RuleRow.default, {
          key: "hideRule" + index,
          hasQueryParamAccess: hasQueryParamAccess,
          hasExclusionAccess: hasExclusionAccess,
          hasContainsAccess: hasContainsAccess,
          hasMore: rulesList.length > 1,
          index: index,
          isDefault: index === 0,
          isParam: rule.isParam,
          isWhiteList: false,
          onValidate: function onValidate() {
            return _this4.validateInputs(targetingOptions);
          },
          onChange: _this4.handleRuleChange,
          onDelete: _this4.handleDelete,
          paramKey: rule.key,
          startsWith: rule.startsWith,
          isContains: rule.isContains,
          isExactMatch: rule.isExactMatch,
          value: rule.value,
          newlyAdded: rule.newlyAdded || false
        });
      })), _react.default.createElement(_UITileSection.default, null, _react.default.createElement(_UIButton.default, {
        className: "targeting-options__rules__add-button",
        onClick: this.handleAddRule('hide'),
        use: "link"
      }, _react.default.createElement(_UIIcon.default, {
        name: 'add'
      }), _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('addRule')
      })))));
    }
  }, {
    key: "renderShowRules",
    value: function renderShowRules() {
      var _this5 = this;

      var _this$props5 = this.props,
          hasQueryParamAccess = _this$props5.hasQueryParamAccess,
          hasExclusionAccess = _this$props5.hasExclusionAccess,
          hasContainsAccess = _this$props5.hasContainsAccess,
          targetingOptions = _this$props5.targetingOptions;
      var rulesList = this.state.rules.whiteList;
      return _react.default.createElement(_UITile.default, {
        compact: true
      }, _react.default.createElement(_UITileSection.default, null, rulesList.map(function (rule, index) {
        return _react.default.createElement(_RuleRow.default, {
          key: "showRule" + index,
          hasQueryParamAccess: hasQueryParamAccess,
          hasExclusionAccess: hasExclusionAccess,
          hasContainsAccess: hasContainsAccess,
          hasMore: rulesList.length > 1,
          index: index,
          isDefault: index === 0,
          isParam: rule.isParam,
          isWhiteList: true,
          onValidate: function onValidate() {
            return _this5.validateInputs(targetingOptions);
          },
          onChange: _this5.handleRuleChange,
          onDelete: _this5.handleDelete,
          paramKey: rule.key,
          startsWith: rule.startsWith,
          isContains: rule.isContains,
          isExactMatch: rule.isExactMatch,
          value: rule.isParam && Array.isArray(rule.value) ? rule.value[0] : rule.value,
          newlyAdded: rule.newlyAdded || false
        });
      })), _react.default.createElement(_UITileSection.default, null, _react.default.createElement(_UITooltip.default, {
        disabled: this.state.enableAddRules,
        title: _I18n.default.text(this.getLangKey('addRuleTooltip'))
      }, _react.default.createElement(_UIButton.default, {
        className: "targeting-options__rules__add-button show",
        disabled: Boolean(!this.state.enableAddRules || rulesList.length === 0),
        onClick: this.handleAddRule('show'),
        use: "link"
      }, _react.default.createElement(_UIIcon.default, {
        name: 'add'
      }), _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('addRule')
      }))), this.maybeRenderAddHideRule()));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UISection.default, {
        className: "targeting-options"
      }, _react.default.createElement("div", {
        className: "targeting-options__manager-title"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('titleShow')
      })), this.renderShowRules(), this.maybeRenderSeparator(), this.maybeRenderHideRules());
    }
  }]);
  return TargetingOptionsManager;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasQueryParamAccess: (0, _Scopes.hasScope)(state, 'url-targeting-query-param-access'),
    hasExclusionAccess: (0, _Scopes.hasScope)(state, 'url-targeting-exclusion-access'),
    hasContainsAccess: (0, _Scopes.hasScope)(state, 'url-targeting-contains-rule-access')
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(TargetingOptionsManager);

exports.default = _default;
module.exports = exports.default;